__turbopack_context__.v({
  "expanded": "e4hrwa_expanded",
  "faqAnswer": "e4hrwa_faqAnswer",
  "faqCta": "e4hrwa_faqCta",
  "faqQuestion": "e4hrwa_faqQuestion",
  "faqTitle": "e4hrwa_faqTitle",
  "faqWrapper": "e4hrwa_faqWrapper",
});
